import { CalendarDataRelatedBuilder } from "../models/CalendarDataRelatedBuilder";
import { DataRelatedBuilder } from "../models/DataRelatedBuilder";
import { PostDataRelatedBuilder } from "../models/PostDataRelatedBuilder";
import { RecordingDataRelatedBuilder } from "../models/RecordingDataRelatedBuilder";
import { WebinarDataRelatedBuilder } from "../models/WebinarDataRelatedBuilder";
import { SignalDataRelatedBuilder } from "../models/SignalDataRelatedBuilder";

export class DataRelatedFactory {
    constructor() { }

    buildStrategy(contentType: string): DataRelatedBuilder<any> {
        switch (contentType.toLowerCase()) {
            case "news":
            case "analysis":
            case "education":
            case "cryptos": {
                return new PostDataRelatedBuilder();
            } case "events": {
                return new WebinarDataRelatedBuilder();
            } case "videos": {
                return new RecordingDataRelatedBuilder();
            } case "calendar": {
                return new CalendarDataRelatedBuilder();
            } case "signal":{
                return new SignalDataRelatedBuilder();
            }
            default: {
                break;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/tradingstudio/services/dataRelatedFactory.ts